var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5060_20105)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6568 5.65683L10.8487 4.84871L10.0406 5.65683L10.8487 6.46496L11.6568 5.65683ZM5.99997 2.61579e-05L6.8081 0.808148L6.00006 1.61618L6.8081 2.42422L5.99997 3.23234L5.19185 2.42422L5.99989 1.61618L5.19185 0.808148L5.99997 2.61579e-05ZM1.95936 5.65692L1.15124 4.8488L0.343114 5.65692L1.15124 6.46504L1.95936 5.65692ZM5.19185 8.88962L5.99989 9.69766L5.19185 10.5057L5.99997 11.3138L6.8081 10.5057L6.00006 9.69766L6.8081 8.88962L5.99997 8.0815L5.19185 8.88962ZM6.8081 4.04085L5.99997 3.23273L5.19185 4.04085L5.99989 4.84888L5.19185 5.65692L5.99989 6.46496L5.19185 7.27299L5.99997 8.08111L6.8081 7.27299L6.00006 6.46496L6.8081 5.65692L6.00006 4.84888L6.8081 4.04085ZM9.23247 4.84871L10.0406 5.65683L9.23247 6.46496L8.42434 5.65683L9.23247 4.84871ZM7.61622 4.84871L8.42434 5.65683L7.61622 6.46496L6.8081 5.65683L7.61622 4.84871ZM5.19185 5.65683L4.38373 4.84871L3.57561 5.65683L4.38373 6.46496L5.19185 5.65683ZM2.76748 4.84871L3.57561 5.65683L2.76748 6.46496L1.95936 5.65683L2.76748 4.84871Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5060_20105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusS);
export default __webpack_public_path__ + "static/media/plus-s.e6f45bca834059bbd1154c108a926c7d.svg";
export { ForwardRef as ReactComponent };